import React from 'react';
import { Navbar, Container, Button } from 'react-bootstrap';
import { useLogout } from '@/portal/hooks/useLogout.ts';

const TopNavbar: React.FC = () => {
  const handleLogout = useLogout();

  return (
    <Navbar bg="dark" variant="dark" expand="md" className="px-3">
      <Container
        fluid
        className="d-flex justify-content-between align-items-center"
      >
        <Navbar.Brand
          href="/portal"
          className="d-flex align-items-center ps-md-0 ps-4"
        >
          <img
            src="/images/afh-logo-small.webp"
            alt="AFH"
            width="30"
            height="30"
            className="d-inline-block align-top me-2"
          />
          AFH Portal
        </Navbar.Brand>
        <Button onClick={handleLogout} variant="outline-light">
          Logout
        </Button>
      </Container>
    </Navbar>
  );
};

export default TopNavbar;
